import { Legend } from '@amcharts/amcharts4/charts';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Columns, DefaultConfig } from 'ngx-easy-table';
import { Config } from 'protractor';
import { IntranetoldService } from 'src/app/api/intranetold.service';
import { MongoService } from 'src/app/api/mongo.service';
import { variableGlobal } from 'src/app/global.enum';
import { DocumentoMarketingDetalle, DocumentoMarting } from 'src/app/model/ventaModel';

@Component({
  selector: 'app-listahistorialdevolucion',
  templateUrl: './listahistorialdevolucion.component.html',
  styleUrls: ['./listahistorialdevolucion.component.css']
})
export class ListahistorialdevolucionComponent implements OnInit {

  constructor(
    private _mongoService: MongoService,
    private _api: IntranetoldService,
    public activeModal: NgbActiveModal

  ) { }

  public configuration: Config;
  public columns: Columns[];
  data: any;
  dataTable: any = [];
  TaxCode: any;
  dataObjeto: any;
  vendedores:any;
  tablaObjetos:any;
  Encabezado:DocumentoMarting;
  USD=0;
  EUR=0;

  @ViewChild('frmNumeroDocumento', { static: true }) frmNumeroDocumento: TemplateRef<any>;
  @ViewChild('frmEstado', { static: true }) frmEstado: TemplateRef<any>;
  @ViewChild('frmU_IND_EstadosNV', { static: true }) frmU_IND_EstadosNV: TemplateRef<any>;
  @ViewChild('frmVendedor', { static: true }) frmVendedor: TemplateRef<any>;
  @ViewChild('frmFechaDocumento', { static: true }) frmFechaDocumento: TemplateRef<any>;
  @ViewChild('frmFechaEntrega', { static: true }) frmFechaEntrega: TemplateRef<any>;
  @ViewChild('frmDocTotal', { static: true }) frmDocTotal: TemplateRef<any>;
  @ViewChild('frmAccion', { static: true }) frmAccion: TemplateRef<any>;

  ngOnInit(): void {
    this.cargaInicial();
  }

  async cargaInicial() {

    var objeto = "SELECT * FROM [OSLP]";
    var dato: any = await this._api.GetNotFileQuery(objeto);
    this.vendedores = dato.objeto;

    

    this.tablaObjetos = await this._mongoService.getTablaObjetos();

    

    this.tablaObjetos.forEach(element => {
      if (element.ObjType == this.data.ObjType) {
        this.dataObjeto = element;
      }
    });

    

    this.dataObjeto.OBJTYPE_SIGUIENTE.forEach(async element => {

      let objeto = this.tablaObjetos.filter(x => x.ObjType == element.Objtype)[0];
      
      let query =
        `SELECT 
        *
        FROM 
            [${objeto.TABLA}] T0
        WHERE T0.[CardCode] = '${this.data.CardCode}' AND T0.[DocStatus] = 'O'
        ORDER BY 
            T0.[DocDate] DESC;`

      let res: any = await this._api.GetNotFileQuery(query);

      

      if (res.estado) {
        this.dataTable = [...this.dataTable,...res.objeto]
      }

    });

    this.columns = [
      { key: 'DocEntry', title: 'Tipo', width: "100px", cellTemplate: this.frmAccion },
      { key: 'DocNum', title: "N°", width: "100px", cellTemplate: this.frmNumeroDocumento },
      { key: 'DocStatus', title: 'Estado', width: "100px", cellTemplate: this.frmEstado },
      { key: 'DocCur', title: 'Moneda', width: "100px" },
      { key: 'CardName', title: 'Cliente', width: "300px" },
      { key: 'VendedorNombre', title: 'Vendedor', width: "300px", cellTemplate: this.frmVendedor },
      { key: 'DocDate', title: 'Fecha documento', cellTemplate: this.frmFechaDocumento },
      { key: 'DocTotal', title: 'Total Neto', cellTemplate: this.frmDocTotal },
    ];

    this.configuration = {
      ...DefaultConfig,
      searchEnabled: true,
      detailsTemplate: false,
      paginationRangeEnabled: false,

      horizontalScroll: true,
      resizeColumn: true,
      orderEnabled: true,
      rowReorder: false,
      columnReorder: false,
      fixedColumnWidth: false,
      selectRow: false,

      paginationEnabled: true,
      //radio:true
      //infiniteScroll:true,
      //infiniteScrollThrottleTime: 10,
      //rows:10,

    };
  }

  vendedorCodigoATexto(slpCode) {
    var SlpName = "";
    this.vendedores.forEach(function (a) {
      if (a) {
        if (a.SlpCode == slpCode) {
          SlpName = a.SlpName;
        }
      }

    })
    return SlpName;
  }

  eventEmitted($event): void {

    var data: any = $event.value.row;
    if ($event.event == "onDoubleClick") {
      

      this.tablaObjetos.forEach(async element => {
        if (element.ObjType == data.ObjType) {
          let tablaDetalle = this.tablaADetalle(element.TABLA);
          

          let query = `SELECT * FROM [${tablaDetalle}] WHERE [DocEntry] = ${data.DocEntry}`
          let res:any = await this._api.GetNotFileQuery(query);
          
          if (res.estado) {

            let arregloDetalleFinal = [];

            let arregloDetalle = res.objeto;

            arregloDetalle.forEach(element => {

              let Detalle:DocumentoMarketingDetalle = {
                LineNum: null,
                BaseEntry: -1,
                BaseLine: -1,
                BaseType: null,
                Account: null,
                ItemCode: null,
                Dscription: null,
                Factor1: null,
                Factor2: null,
                Quantity: null,
                Price: null,
                Disc: this.data.DescuentoCampoUsuario,
                PriceAfeterDisc: this.data.DescuentoCampoUsuario,
                LineTotal: null,
                OnHand: null,
                TaxCode: this.TaxCode,
                WhsCode: null,
                DimCode1: null,
                DimCode2: null,
                DimCode3: null,
                DimCode4: null,
                DimCode5: null,
                Currency: this.data.Currency,
                Lote: [],
                Serie: [],
                ManBtchNum: null,
                ManSerNum: null,
                CantidadPickeada: null,
                CantidadPendiente: null,
                ocultaLote: true,
                ocultaSerie: true,
                UserFields: [{
                  Field: "U_IND_WMS_ESTADO",
                  FieldType: "string",
                  Value: "T",
                },
        
              ],
              };

              Detalle.LineNum = -1;
              Detalle.VATLiable = element.VATLiable;
              Detalle.ItemCode = element.ItemCode;
              Detalle.Dscription = element.Dscription;
              Detalle.Factor1 = element.Factor1;
              Detalle.Factor2 = element.Factor2;
              Detalle.FrgnName = element.FrgnName;

              if(!element.Price)
              {
                element.Price=0;
              }

              Detalle.Price = element.Price.toFixed(variableGlobal.DECIMALES_CLP);
              Detalle.Disc = 0;
              Detalle.OnHand = element.OnHand;
              Detalle.WhsCode = element.WhsCode;
              Detalle.Currency = element.Currency
              Detalle.Quantity = 1;
              Detalle.ManSerNum = element.ManSerNum;
              Detalle.ManBtchNum = element.ManBtchNum;
              Detalle.PrecioOG = element.Price;
              Detalle.CurrencyOG = element.Currency;
              Detalle.SalUnitMsr = element.SalUnitMsr;
              Detalle.BuyUnitMsr = element.BuyUnitMsr;

              Detalle.UserFields = [
                {
                  Field:"U_IND_TIPO",
                  FieldType: "String",
                  Value:element.U_IND_TIPO
                },
                {
                  Field:"U_IND_WMS_ESTADO",
                  FieldType: "String",
                  Value:"T"
                },
                {
                  Field:"U_IND_SWW",
                  FieldType: "String",
                  Value:element.U_IND_SWW
                },
              ];


              if (this.Encabezado.Currency != "CLP") {
                if(this.Encabezado.Currency != element.Currency)
                {
                  if(!element.PriceOther){
                    element.PriceOther=0;
                  }
                  Detalle.Price = element.PriceOther.toFixed(variableGlobal.DECIMALES_OTRA_MONEDA);
                  Detalle.Currency = this.Encabezado.Currency;
                }else{
                  Detalle.Price = element.Price.toFixed(variableGlobal.DECIMALES_OTRA_MONEDA);
                }

              }

              if(element.Currency!="CLP" && this.Encabezado.Currency=="CLP"){

                if(element.Currency == "USD"){
                  Detalle.Price=element.Price * this.USD;
                }


              }

              
              if (this.Encabezado.ObjType == "17") {
                if (Detalle.ManBtchNum == "Y") {
                  Detalle.ocultaLote = false;
                }
                if (Detalle.ManSerNum == "Y") {
                  Detalle.ocultaSerie = false;
                }

              }

              arregloDetalleFinal.push(Detalle)
            });
            
            
            this.activeModal.close(arregloDetalleFinal);

          }
        }
      });
    }

  }

  tablaADetalle(texto: string): string {
    if (texto.length > 0) {
        return texto.slice(1) + "1";
    }
    return "1";
  }

  cerrar() {
    this.activeModal.close();
  }

}
